import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
    palette: {
        primary: {
            main: '#1976d2'
        },
        secondary: {
            50: "#fff8f5",
            100: "#ffefe6",
            200: "#ffd8bf",
            300: "#ffb08e",
            400: "#ff8a4f",
            500: "#ff5f1a",
            600: "#d14814",
            700: "#8f2f0f",
            800: "#5a1d0a",
            900: "#2d0f05",
            main: "#ff5f1a",
        },
        accent: {
            main: "#ffb020",
        },
        neutral: {
            50: "#fafafa",
            100: "#f3f4f6",
            200: "#e5e7eb",
            300: "#d1d5db",
            400: "#9ca3af",
            500: "#6b7280",
            600: "#4b5563",
            700: "#374151",
            800: "#1f2937",
            900: "#0b1220",
            main: "#6b7280",
        },
        error: {
            main: '#d32f2f'
        },
        warning: {
            main: '#ed6c02'
        },
        info: {
            main: '#0288d1'
        },
        success: {
            main: '#2e7d32'
        },
        sidebar: {
            main: '#515151',
        }, 
        background: {
            main: '#E5E5E5'
        },
    },
    typography: {
        fontFamily: ["Inter", "system-ui", "sans-serif"].join(","),
        heading: {
            fontFamily: ["Poppins", "Inter", "system-ui", "sans-serif"].join(","),
        },
        mono: {
            fontFamily: ["monospace"].join(","),
        },
        highlight: {
            fontWeight: 600, 
            color: '#202034',
        },
    },
    shape: {
        borderRadius: 4, // default
        xl: "1rem",
        "2xl": "1.5rem",
    },
    shadows: [
        "none",
        "0 1px 3px rgba(10, 37, 64, 0.06)", // elevated-sm
        "0 6px 20px rgba(10, 37, 64, 0.12)", // elevated
        ...Array(23).fill("none"), // fill rest to match MUI's 25 shadow slots
    ],
});
